import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getFeaturesData = createAsyncThunk("ListingPublicData/getFeaturesData", async (data, thunkAPI) => {
  try {
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}api/transactions/listing/public-data/features/${data.listing_public_data_id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
